import { locationSlugs, termSlugs } from "@src/constants";

export function isLocationSlug(slug) {
    return locationSlugs.some((locationSlug) => locationSlug.slug === slug);
}

export function isTermSlug(slug) {
    return termSlugs.some((termSlug) => termSlug.slug === slug);
}